import type { CustomerCalendar } from '@/types/generated'

export function calendarSupportsParticipantInvites(
  calendar: CustomerCalendar | null | undefined
): boolean {
  return calendar?.supports_participant_invites === true
}
